// src/utils/notificationFilters.ts
import { InAppNotification } from "src/layouts/MyAccount/Notifications/NotificationInterfaces";

export const filterToday = (notifications: InAppNotification[]): InAppNotification[] => {
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);
  const todayEnd = new Date();
  todayEnd.setHours(23, 59, 59, 999);

  return notifications.filter(n => {
    const created = new Date(n.created_at);
    return created >= todayStart && created <= todayEnd;
  });
};

export const filterThisWeek = (
  notifications: InAppNotification[]
): InAppNotification[] => {
  const now = new Date();
  const day = now.getDay();
  const startOfWeek = new Date(now);
  startOfWeek.setDate(now.getDate() - day);
  startOfWeek.setHours(0, 0, 0, 0);

  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  endOfWeek.setHours(23, 59, 59, 999);

  return notifications.filter(n => {
    const created = new Date(n.created_at);
    return created >= startOfWeek && created <= endOfWeek;
  });
};

const PKT_OFFSET_MS = 5 * 60 * 60 * 1000;

// Backend date filters bucket on fixed PKT (UTC+5) days, not browser-local time.
export const toPktDateString = (isoString: string): string => {
  const shifted = new Date(new Date(isoString).getTime() + PKT_OFFSET_MS);
  const year = shifted.getUTCFullYear();
  const month = String(shifted.getUTCMonth() + 1).padStart(2, "0");
  const day = String(shifted.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
